import { ImportBundle, createdThumbs, initFancyBox, handleSendInquiry } from "../common";
import { init } from "../mainEntry";
import sideBar1_Init from "../components/sideBar-1";
import Swiper from "swiper11";
import { Autoplay, Navigation, Thumbs } from "swiper11/modules";
import dialogFormInit from "../components/dialogForm-1";
init().then(() => {
  common();
  initSwiper();
  initEvent();
});

function common() {
  initFancyBox();
  ImportBundle({ type: "js" }, [
    {
      src: "https://static.addtoany.com/menu/page.js",
      async: true,
      fn: () => {
        let a2a_config = window.a2a_config || {};
        a2a_config.onclick = 1;
        window.a2a_config = a2a_config;
      },
    },
    {
      src: "https://static.yigetechcms.com/public/js/bootstrap@4.6.2.min.js",
    },
  ]);
  ImportBundle({ type: "css" }, ["https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css", "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css"]);
}

function initEvent() {
  dialogFormInit();
  sideBar1_Init();
  handleSendInquiry({ formId: "#Inquiry-form", trigger: "#Inquiry-submit" });
}

function initSwiper() {
  new Swiper(".productDetail-1 .productDetail-1_main .main-swiper .swiper", {
    modules: [Autoplay, Thumbs, Navigation],
    loop: true,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 650,
    spaceBetween: 30,
    navigation: {
      prevEl: ".productDetail-1 .productDetail-1_main .thumbs-swiper .prev",
      nextEl: ".productDetail-1 .productDetail-1_main .thumbs-swiper .next",
    },
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, ".productDetail-1 .productDetail-1_main .thumbs-swiper .swiper", {
          swiperOptions: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        });
      },
    },
  });
}
